import { render, staticRenderFns } from "./OrderReworks.vue?vue&type=template&id=46e55380&"
import script from "./OrderReworks.vue?vue&type=script&lang=js&"
export * from "./OrderReworks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports